import React from 'react';
import { Redirect } from 'react-router-dom';
import RedemptionForm from './RedemptionForm';
import { RedemptionFormData } from './types';
import api from 'utils/api-services';
import { PageLayout } from '../../layouts';

const PAGE_STATUS: {
  REDEEMING: 'redeeming',
  FAILED: 'failed',
  SUCCESS: 'success'
} = {
  REDEEMING: 'redeeming',
  FAILED: 'failed',
  SUCCESS: 'success'
};

type PageStatus = typeof PAGE_STATUS[keyof typeof PAGE_STATUS];

interface Props {
  onNameChange: (name: string) => void
}

interface State {
  status: PageStatus;
  errorMessage?: string;
}

class RedeemPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      status: PAGE_STATUS.REDEEMING
    }
  }

  handleSubmit = async (values: RedemptionFormData, setSubmitting: (isSubmitted: boolean) => void) => {
    const res = await api.postRedeemGiftCard({
      cardNumber: values.giftCardCode,
      cvvCode: values.giftCardCvv,
      expirationMonth: parseInt(values.giftCardExpirationMonth),
      expirationYear: parseInt(values.giftCardExpirationYear),
      firstName: values.firstName,
      lastName: values.lastName
    });

    setSubmitting(true);

    if (!res.isSuccess) {
      console.log('got an error');
      if (res.status === 422) {
        this.setState({
          errorMessage: res.errorMessage,
          status: PAGE_STATUS.REDEEMING
        });
        setSubmitting(false);
      } else {
        this.setState({
          errorMessage: res.errorMessage,
          status: PAGE_STATUS.FAILED
        });
      }
    } else if (res.isSuccess) {
      this.props.onNameChange(values.firstName);
      this.setState({
        status: PAGE_STATUS.SUCCESS
      });
      console.log('success');
    } else {
      console.log('failure');
    }
  }

  render() {
    const { errorMessage, status } = this.state;
    return (
      <PageLayout>

        {status === PAGE_STATUS.REDEEMING && (
          <RedemptionForm
            apiErrorMessage={errorMessage}
            onSubmit={this.handleSubmit}
          />
        )}
        {status === PAGE_STATUS.SUCCESS && (
          <Redirect to={`${process.env.PUBLIC_URL}/success`} push />
        )}
        {status === PAGE_STATUS.FAILED && (
          <Redirect to={`${process.env.PUBLIC_URL}/ineligible`} push />
        )}
      </PageLayout>
    );
  }
}
export default RedeemPage;
